@let installmentCompleted = response()?.status === 'completed' && response()?.action_type === 'payment' && response()?.current_step === 'installment_contract_review';
<div class="quick-action-wizard">
  <section
    class="quick-action-wizard__panel"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="installmentCompleted ? 'quick-action-wizard-success' : dialogTitleId"
    [attr.aria-describedby]="validation() ? 'quick-action-wizard-validation' : null">
    @if (!installmentCompleted) {
      <header class="quick-action-wizard__header">
        @if (response()?.status !== 'completed' && canGoBack()) {
          <button type="button" class="quick-action-wizard__back" data-track="wizard_back" (click)="goBack()" [attr.aria-label]="'quickActionWizard.back' | t">
            {{ 'quickActionWizard.back' | t }}
          </button>
        }
        <div class="quick-action-wizard__heading">
          <h2 [id]="dialogTitleId">{{ response() ? localizedTitle(response()!) : ('quickActionWizard.fallbackTitle' | t) }}</h2>
        </div>
        <div class="quick-action-wizard__header-actions">
          @if (response()?.status !== 'completed') {
            <button type="button" class="quick-action-wizard__close" data-track="wizard_close" (click)="requestClose()" [attr.aria-label]="'quickActionWizard.closeDialog' | t">
              <span aria-hidden="true">×</span>
            </button>
          }
        </div>
      </header>
    }

    <div class="quick-action-wizard__body">
      @if (loading()) {
        <div class="quick-action-wizard__state" role="status">
          <span class="quick-action-wizard__spinner" aria-hidden="true"></span>
          <p>{{ 'quickActionWizard.loading' | t }}</p>
        </div>
      } @else if (error()) {
        <div class="quick-action-wizard__state quick-action-wizard__state--error" role="alert">
          <strong>{{ 'quickActionWizard.interrupted' | t }}</strong>
          <p>{{ error() }}</p>
          @if (contactAvailable()) {
            <button type="button" class="quick-action-wizard__primary" data-testid="blocked-contact" [disabled]="loading()" (click)="openContactForm()">{{ 'chat.actions.contactForm' | t }}</button>
          }
        </div>
      } @else if (response(); as current) {
        @if (current.status === 'completed') {
          <div class="quick-action-wizard__success" role="status">
            <span class="quick-action-wizard__success-badge" aria-hidden="true"></span>
            <strong id="quick-action-wizard-success">{{ 'quickActionWizard.done' | t }}</strong>
            <p>{{ localizedCompletionMessage(current) }}</p>
            @if (installmentCompleted && submittedContractPayload()) {
              <button type="button" class="quick-action-wizard__primary" data-testid="installment-contract-completed-download" [disabled]="loading()" data-track="contract_download" (click)="downloadInstallmentContract($event)">
                {{ 'quickActionWizard.downloadContract' | t }}
              </button>
            }
            <button type="button" class="quick-action-wizard__primary quick-action-wizard__success-close" data-track="wizard_confirm_close" (click)="confirmClose()">
              {{ 'common.close' | t }}
            </button>
          </div>
        } @else if (current.status === 'blocked') {
          <div class="quick-action-wizard__notice" role="status">
            <span class="quick-action-wizard__state-icon" aria-hidden="true">!</span>
            <strong>{{ 'quickActionWizard.currentlyUnavailable' | t }}</strong>
            <p>{{ localizedCompletionMessage(current) }}</p>
            <button type="button" class="quick-action-wizard__primary" data-testid="blocked-contact" [disabled]="loading()" (click)="openContactForm()">{{ 'chat.actions.contactForm' | t }}</button>
          </div>
        } @else {

          @if (validation(); as validationState) {
            <p id="quick-action-wizard-validation" class="quick-action-wizard__validation" role="alert">
              <span aria-hidden="true">!</span>
              {{ validationSummary() }}
            </p>
          }

          @if (devTestDataConfirmation(); as confirmation) {
            <p class="quick-action-wizard__dev-confirmation" role="status">
              <span aria-hidden="true">✓</span>
              {{ confirmation }}
            </p>
          }

          @if (shouldShowWidgetCards(current)) {
            <div class="quick-action-wizard__widgets">
              <app-widget-card [widgets]="current.widgets"></app-widget-card>
            </div>
          }

          @switch (current.current_step) {
          @case ('payment_method') {
            <section class="quick-action-wizard__payment-start">
              @if (paymentClaimSummary(current); as summary) {
                <div class="quick-action-wizard__payment-head">
                  <div class="quick-action-wizard__claim-total">
                    <span class="quick-action-wizard__eyebrow">{{ 'quickActionWizard.openClaim' | t }}</span>
                    <strong>{{ summary.total }}</strong>
                  </div>
                  <dl class="quick-action-wizard__claim-meta">
                    @if (summary.reference) {
                      <div><dt>{{ 'quickActionWizard.reference' | t }}</dt><dd>{{ summary.reference }}</dd></div>
                    }
                    @if (summary.creditor) {
                      <div><dt>{{ 'quickActionWizard.creditor' | t }}</dt><dd>{{ summary.creditor }}</dd></div>
                    }
                  </dl>
                </div>
              }

              <p>{{ 'quickActionWizard.choosePaymentMethod' | t }}</p>
            </section>

            <div class="quick-action-wizard__payment-methods">
              <div class="quick-action-wizard__payment-methods-head">
                <strong>{{ 'quickActionWizard.paymentType' | t }}</strong>
              </div>
              <div class="quick-action-wizard__options">
                @for (option of current.allowed_options; track option.id) {
                  <button
                    type="button"
                    class="quick-action-wizard__option"
                    [class.quick-action-wizard__option--disabled]="!option.enabled"
                    [disabled]="!option.enabled"
                    data-track="payment_method" (click)="choosePaymentMethod(option.id)">
                    <span class="quick-action-wizard__option-head">
                      <strong>{{ localizedPaymentOptionLabel(option) }}</strong>
                      @if (localizedPaymentOptionHint(option); as optionHint) {
                        <small>{{ optionHint }}</small>
                      }
                    </span>
                  </button>
                }
              </div>
            </div>
          }

            @case ('transfer_details') {
            @if (transferDetails(current); as transfer) {
              <section class="quick-action-wizard__transfer" aria-labelledby="quick-action-transfer-title">
                <div class="quick-action-wizard__info-box">
                  <strong id="quick-action-transfer-title">{{ 'quickActionWizard.transfer' | t }}</strong>
                  <span>{{ 'quickActionWizard.transferInfo' | t }}</span>
                </div>

                <dl class="quick-action-wizard__summary-list">
                  @if (transfer.amount) {
                    <div>
                      <dt>{{ 'quickActionWizard.amount' | t }}</dt>
                      <dd>{{ transfer.amount }}</dd>
                    </div>
            }
                  <div>
                    <dt>{{ 'quickActionWizard.recipient' | t }}</dt>
                    <dd>{{ transfer.recipient || ('quickActionWizard.unavailable' | t) }}</dd>
                  </div>
                  <div>
                    <dt>{{ 'caseView.detailLabels.bank_iban' | t }}</dt>
                    <dd class="quick-action-wizard__mono">{{ transfer.iban || ('quickActionWizard.unavailable' | t) }}</dd>
                  </div>
                  @if (transfer.bic) {
                    <div>
                      <dt>{{ 'caseView.detailLabels.bank_bic' | t }}</dt>
                      <dd class="quick-action-wizard__mono">{{ transfer.bic }}</dd>
                    </div>
                  }
                  @if (transfer.bank) {
                    <div>
                      <dt>{{ 'caseView.detailLabels.bank_name' | t }}</dt>
                      <dd>{{ transfer.bank }}</dd>
                    </div>
                  }
                  <div>
                    <dt>{{ 'quickActionWizard.referencePurpose' | t }}</dt>
                    <dd class="quick-action-wizard__mono">{{ transfer.reference || ('quickActionWizard.referenceFallback' | t) }}</dd>
                  </div>
                </dl>

                <div class="quick-action-wizard__qr-section">
                  <div class="quick-action-wizard__qr-copy">
                    <strong>GiroCode</strong>
                    <span>{{ 'quickActionWizard.giroCodeInfo' | t }}</span>
                  </div>
                  <div class="quick-action-wizard__qr-box">
                    @if (transferQrCode(); as qrCode) {
                      <img [src]="qrCode" [alt]="'GiroCode'">
                    } @else if (transferQrUnavailable()) {
                      <span>{{ 'quickActionWizard.giroCodeUnavailable' | t }}</span>
                    } @else {
                      <span>{{ 'quickActionWizard.giroCodePreparing' | t }}</span>
                    }
                  </div>
                </div>
              </section>
            } @else {
              <div class="quick-action-wizard__info-box">
                {{ 'quickActionWizard.bankDataMissing' | t }}
              </div>
            }

            <footer class="quick-action-wizard__footer">
              @if (canGoBack()) {
                <button type="button" class="quick-action-wizard__secondary" data-track="wizard_back" (click)="goBack()">{{ 'quickActionWizard.back' | t }}</button>
              }
              <button type="button" class="quick-action-wizard__primary" data-track="payment_submit" (click)="completeTransfer()">{{ 'quickActionWizard.finish' | t }}</button>
            </footer>
            }

            @case ('installment_transfer_info') {
              @if (transferDetails(current); as transfer) {
                <section class="quick-action-wizard__transfer" aria-labelledby="quick-action-installment-transfer-title">
                  <div class="quick-action-wizard__info-box">
                    <strong id="quick-action-installment-transfer-title">{{ 'quickActionWizard.transferInfoTitle' | t }}</strong>
                    <span>{{ 'quickActionWizard.installmentTransferInfo' | t }}</span>
                  </div>

                  <dl class="quick-action-wizard__summary-list">
                    @if (installmentSummary(current); as summary) {
                      <div><dt>{{ 'quickActionWizard.regularInstallments' | t }}</dt><dd>{{ summary.regularCount }} x {{ summary.regularAmount }}</dd></div>
                      <div><dt>{{ 'quickActionWizard.finalInstallment' | t }}</dt><dd>1 x {{ summary.finalAmount }}</dd></div>
                      @if (summary.totalAmount) {
                        <div><dt>{{ 'quickActionWizard.totalAmount' | t }}</dt><dd>{{ summary.totalAmount }}</dd></div>
                      }
                    } @else if (transfer.amount) {
                      <div><dt>{{ 'quickActionWizard.amount' | t }}</dt><dd>{{ transfer.amount }}</dd></div>
                    }
                    <div><dt>{{ 'quickActionWizard.rateDate' | t }}</dt><dd>{{ installmentContractValue(current, 'start') || '-' }}</dd></div>
                    <div><dt>{{ 'quickActionWizard.recipient' | t }}</dt><dd>{{ transfer.recipient || ('quickActionWizard.unavailable' | t) }}</dd></div>
                    <div><dt>{{ 'caseView.detailLabels.bank_iban' | t }}</dt><dd class="quick-action-wizard__mono">{{ transfer.iban || ('quickActionWizard.unavailable' | t) }}</dd></div>
                    @if (transfer.bic) { <div><dt>{{ 'caseView.detailLabels.bank_bic' | t }}</dt><dd class="quick-action-wizard__mono">{{ transfer.bic }}</dd></div> }
                    @if (transfer.bank) { <div><dt>{{ 'caseView.detailLabels.bank_name' | t }}</dt><dd>{{ transfer.bank }}</dd></div> }
                    <div><dt>{{ 'quickActionWizard.referencePurpose' | t }}</dt><dd class="quick-action-wizard__mono">{{ transfer.reference || ('quickActionWizard.referenceFallback' | t) }}</dd></div>
                  </dl>
                </section>
              } @else {
                <div class="quick-action-wizard__info-box">{{ 'quickActionWizard.bankDataMissing' | t }}</div>
              }

              <footer class="quick-action-wizard__footer">
                <button type="button" class="quick-action-wizard__secondary" data-track="wizard_back" (click)="goBack()">{{ 'quickActionWizard.back' | t }}</button>
                <button type="button" class="quick-action-wizard__primary" data-track="payment_submit" (click)="completeTransfer()">{{ 'quickActionWizard.next' | t }}</button>
              </footer>
            }

            @case ('sepa_mandate') {
            <div class="quick-action-wizard__info-box">
              {{ 'quickActionWizard.sepaInfo' | t }}
            </div>

            @if (showDevHelper) {
              <div class="quick-action-wizard__dev-helper" role="note">
                <div>
                  <strong>{{ 'modalCommon.devDataTitle' | t }}</strong>
                  <span>{{ 'quickActionWizard.devSepa' | t }}</span>
                </div>
                <button type="button" class="quick-action-wizard__secondary" (click)="insertSepaTestData()">{{ 'modalCommon.insertTestData' | t }}</button>
              </div>
            }

            <form class="quick-action-wizard__form" (ngSubmit)="submitSepa()">
              <label>
                <span>{{ 'caseView.detailLabels.bank_iban' | t }}</span>
                <input
                  type="text"
                  [ngModel]="sepa().iban"
                  (ngModelChange)="updateSepa('iban', $event)"
                  name="sepaIban"
                  autocomplete="off"
                  [attr.aria-invalid]="hasFieldError('iban')"
                  [class.quick-action-wizard__input--error]="hasFieldError('iban')">
                @if (hasFieldError('iban')) { <small>{{ validationMessage('iban') }}</small> }
              </label>
              @if (isInstallmentContext(current)) {
                <label>
                  <span>{{ 'caseView.detailLabels.bank_bic' | t }}</span>
                  <input
                    type="text"
                    [ngModel]="sepa().bic"
                    (ngModelChange)="updateSepa('bic', $event)"
                    name="sepaBic"
                    autocomplete="off"
                    [attr.aria-invalid]="hasFieldError('bic')"
                    [class.quick-action-wizard__input--error]="hasFieldError('bic')">
                  @if (hasFieldError('bic')) { <small>{{ validationMessage('bic') }}</small> }
                </label>
              }
              <div class="quick-action-wizard__field">
                <span>{{ 'quickActionWizard.accountHolder' | t }}</span>
                <strong data-testid="sepa-account-holder">{{ sepaAccountHolder() }}</strong>
                @if (hasFieldError('kontoinhaber')) { <small>{{ validationMessage('kontoinhaber') }}</small> }
              </div>
              @if (isInstallmentContext(current)) {
                <div class="quick-action-wizard__field">
                  <span>{{ 'quickActionWizard.startDate' | t }}</span>
                  <strong data-testid="installment-sepa-start-date">{{ installmentContractValue(current, 'start') }}</strong>
                  @if (hasFieldError('abbuchungstag')) { <small>{{ validationMessage('abbuchungstag') }}</small> }
                </div>
              } @else {
                <label>
                  <span>{{ 'modalCommon.debitDay' | t }}</span>
                  <input
                    type="number"
                    min="1"
                    max="28"
                    [ngModel]="sepa().abbuchungstag"
                    (ngModelChange)="updateSepa('abbuchungstag', $event)"
                    name="sepaAbbuchungstag"
                    [attr.aria-invalid]="hasFieldError('abbuchungstag')"
                    [class.quick-action-wizard__input--error]="hasFieldError('abbuchungstag')">
                  @if (hasFieldError('abbuchungstag')) { <small>{{ validationMessage('abbuchungstag') }}</small> }
                </label>
              }

              <label class="quick-action-wizard__confirmation">
                <input
                  type="checkbox"
                  [ngModel]="sepaMandateAccepted()"
                  (ngModelChange)="updateSepaMandateAccepted($event)"
                  name="sepaMandateAccepted">
                <span>
                  {{ 'quickActionWizard.sepaMandate' | t }}
                </span>
                @if (hasFieldError('mandate')) { <small>{{ validationMessage('mandate') }}</small> }
              </label>

              <footer class="quick-action-wizard__footer">
                @if (canGoBack()) {
                  <button type="button" class="quick-action-wizard__secondary" data-track="wizard_back" (click)="goBack()">{{ 'quickActionWizard.back' | t }}</button>
                }
                  <button type="submit" data-track="payment_submit" class="quick-action-wizard__primary">{{ 'quickActionWizard.next' | t }}</button>
              </footer>
            </form>
          }

          @case ('installment_terms') {
            <div class="quick-action-wizard__info-box">
              <strong>{{ 'quickActionWizard.installment' | t }}</strong>
              <span>{{ 'quickActionWizard.installmentInfo' | t }}</span>
            </div>

            @if (showDevHelper) {
              <div class="quick-action-wizard__dev-helper" role="note">
                <div>
                  <strong>{{ 'modalCommon.devDataTitle' | t }}</strong>
                  <span>{{ 'quickActionWizard.devInstallment' | t }}</span>
                </div>
                <button type="button" class="quick-action-wizard__secondary" (click)="insertInstallmentTestData()">{{ 'modalCommon.insertTestData' | t }}</button>
              </div>
            }

            <form class="quick-action-wizard__form" (ngSubmit)="submitInstallment()">
                <label>
                  <span>{{ 'quickActionWizard.startDate' | t }}</span>
                <select
                    [ngModel]="installment().start"
                    (ngModelChange)="updateInstallment('start', $event)"
                    name="installmentStart"
                    [attr.aria-invalid]="hasFieldError('start')"
                    [class.quick-action-wizard__input--error]="hasFieldError('start')">
                    <option value="" disabled>{{ 'modalCommon.choose' | t }}</option>
                    @for (option of installmentStartOptions(current); track option.id) {
                      <option [value]="option.id">{{ option.label }}</option>
                    }
                  </select>
                  @if (hasFieldError('start')) { <small>{{ validationMessage('start') }}</small> }
                </label>
                <label>
                  <span>{{ 'quickActionWizard.duration' | t }}</span>
                  <select
                    [ngModel]="installment().duration_months"
                    (ngModelChange)="updateInstallment('duration_months', $event)"
                    name="installmentDuration"
                    [attr.aria-invalid]="hasFieldError('duration_months')"
                    [class.quick-action-wizard__input--error]="hasFieldError('duration_months')">
                    @for (option of installmentDurationOptions(current); track option.id) {
                      <option [value]="option.id">{{ installmentDurationLabel(option.id) }}</option>
                    }
                  </select>
                  @if (hasFieldError('duration_months')) { <small>{{ validationMessage('duration_months') }}</small> }
                </label>
              <fieldset>
                <legend>{{ 'quickActionWizard.paymentMethod' | t }}</legend>
                <label class="quick-action-wizard__radio">
                  <input
                    type="radio"
                    name="installmentPaymentMethod"
                    value="transfer"
                    [ngModel]="installment().payment_method"
                    (ngModelChange)="updateInstallment('payment_method', $event)">
                  <span>{{ 'quickActionWizard.transfer' | t }}</span>
                </label>
                <label class="quick-action-wizard__radio">
                  <input
                    type="radio"
                    name="installmentPaymentMethod"
                    value="sepa"
                    [ngModel]="installment().payment_method"
                    (ngModelChange)="updateInstallment('payment_method', $event)">
                  <span>{{ 'quickActionWizard.directDebit' | t }}</span>
                </label>
                @if (hasFieldError('payment_method')) { <small>{{ validationMessage('payment_method') }}</small> }
              </fieldset>
                @if (installment().duration_months && current.form_schema?.conditions) {
                  <section class="quick-action-wizard__review-card quick-action-wizard__review-card--muted">
                    <h3 class="quick-action-wizard__review-card-title">{{ 'quickActionWizard.conditionsTitle' | t }}</h3>
                    <dl class="quick-action-wizard__conditions quick-action-wizard__conditions--inline">
                      @if (selectedInstallmentSummary(current); as summary) {
                        <div><dt>{{ 'quickActionWizard.regularInstallments' | t }}</dt><dd>{{ summary.regularCount }} x {{ summary.regularAmount }}</dd></div>
                        <div><dt>{{ 'quickActionWizard.finalInstallment' | t }}</dt><dd>1 x {{ summary.finalAmount }}</dd></div>
                        @if (summary.totalAmount) {
                          <div><dt>{{ 'quickActionWizard.totalAmount' | t }}</dt><dd>{{ summary.totalAmount }}</dd></div>
                        }
                      } @else {
                        <div><dt>{{ 'quickActionWizard.rate' | t }}</dt><dd>{{ selectedInstallmentRate(current) }}</dd></div>
                      }
                    </dl>
                    @if (selectedInstallmentFeeIsWaived(current) && feeWaivedUntilRates(current) === 2) {
                      <p class="quick-action-wizard__fee-waiver">
                        {{ 'quickActionWizard.feeWaiverExplanation' | t:{ fee: installmentFeeForPaidPlan(current) } }}
                      </p>
                    } @else if (!selectedInstallmentFeeIsWaived(current)) {
                      <dl class="quick-action-wizard__fee-summary">
                        <div>
                          <dt>{{ 'quickActionWizard.rzvFee' | t }}</dt>
                          <dd>{{ selectedInstallmentFeeTotal(current) }}</dd>
                        </div>
                        <div><dt>{{ 'quickActionWizard.rzvFeeHonorar' | t }}</dt><dd>{{ selectedInstallmentFeeHonorar(current) }}</dd></div>
                        <div><dt>{{ 'quickActionWizard.rzvFeeAuslagen' | t }}</dt><dd>{{ selectedInstallmentFeeAuslagen(current) }}</dd></div>
                      </dl>
                    }
                  </section>
                }
                <div class="quick-action-wizard__actions">
                  <button type="button" class="quick-action-wizard__secondary" data-track="wizard_close" (click)="requestClose()">{{ 'common.cancel' | t }}</button>
                  <button type="submit" class="quick-action-wizard__primary">{{ 'quickActionWizard.next' | t }}</button>
                </div>
              </form>
            }

            @case ('payment_contract') {
            <section class="quick-action-wizard__contract-overview" aria-labelledby="quick-action-contract-title">
              <div class="quick-action-wizard__section-head">
                <strong id="quick-action-contract-title">{{ 'quickActionWizard.installment' | t }}</strong>
                <span>{{ 'quickActionWizard.contractInfo' | t }}</span>
              </div>

              @if (current.modal?.modalData; as contract) {
                <dl class="quick-action-wizard__conditions quick-action-wizard__conditions--cards" [attr.aria-label]="'quickActionWizard.installmentTermsAria' | t">
                  @if (installmentSummary(current); as summary) {
                    <div><dt>{{ 'quickActionWizard.regularInstallments' | t }}</dt><dd>{{ summary.regularCount }} x {{ summary.regularAmount }}</dd></div>
                    <div><dt>{{ 'quickActionWizard.finalInstallment' | t }}</dt><dd>1 x {{ summary.finalAmount }}</dd></div>
                    @if (summary.totalAmount) {
                      <div><dt>{{ 'quickActionWizard.totalAmount' | t }}</dt><dd>{{ summary.totalAmount }}</dd></div>
                    }
                  } @else if (installmentSchedule(current).length > 0) {
                    @for (installment of installmentSchedule(current); track installment.index) {
                      <div><dt>{{ 'widget.installment' | t }} {{ installment.index }} · {{ installment.due_date }}</dt><dd>{{ installment.amount }}</dd></div>
                    }
                  } @else {
                    <div><dt>{{ 'quickActionWizard.rate' | t }}</dt><dd>{{ contract['rate'] }}</dd></div>
                  }
                  <div><dt>{{ 'widget.start' | t }}</dt><dd>{{ installmentContractValue(current, 'start') }}</dd></div>
                  <div><dt>{{ 'quickActionWizard.duration' | t }}</dt><dd>{{ contract['laufzeit'] }}</dd></div>
                </dl>
              }

              @if (transferDetails(current); as transfer) {
                <div class="quick-action-wizard__section-head quick-action-wizard__section-head--compact">
                  <strong>{{ 'quickActionWizard.bankTransferData' | t }}</strong>
                  <span>{{ 'quickActionWizard.bankTransferInfo' | t }}</span>
                </div>

                <dl class="quick-action-wizard__summary-list" [attr.aria-label]="'quickActionWizard.bankTransferAria' | t">
                  <div>
                    <dt>{{ 'quickActionWizard.recipient' | t }}</dt>
                    <dd>{{ transfer.recipient || ('quickActionWizard.unavailable' | t) }}</dd>
                  </div>
                  <div>
                    <dt>{{ 'caseView.detailLabels.bank_iban' | t }}</dt>
                    <dd class="quick-action-wizard__mono">{{ transfer.iban || ('quickActionWizard.unavailable' | t) }}</dd>
                  </div>
                  @if (transfer.bic) {
                    <div>
                      <dt>{{ 'caseView.detailLabels.bank_bic' | t }}</dt>
                      <dd class="quick-action-wizard__mono">{{ transfer.bic }}</dd>
                    </div>
                  }
                  @if (transfer.bank) {
                    <div>
                      <dt>{{ 'caseView.detailLabels.bank_name' | t }}</dt>
                      <dd>{{ transfer.bank }}</dd>
                    </div>
                  }
                  <div>
                    <dt>{{ 'quickActionWizard.referencePurpose' | t }}</dt>
                    <dd class="quick-action-wizard__mono">{{ transfer.reference || ('quickActionWizard.referenceFallback' | t) }}</dd>
                  </div>
                  @if (transfer.amount) {
                    <div>
                      <dt>{{ 'quickActionWizard.amount' | t }}</dt>
                      <dd>{{ transfer.amount }}</dd>
                    </div>
                  }
                </dl>
              }
            </section>

            @if (showDevHelper) {
              <div class="quick-action-wizard__dev-helper" role="note">
                <div>
                  <strong>{{ 'modalCommon.devDataTitle' | t }}</strong>
                  <span>{{ 'quickActionWizard.devContractInserted' | t }}</span>
                </div>
                <button type="button" class="quick-action-wizard__secondary" (click)="insertPaymentContractTestData()">{{ 'modalCommon.insertTestData' | t }}</button>
              </div>
            }

            <form class="quick-action-wizard__form" (ngSubmit)="submitPaymentContract()">
              <label>
                <span>{{ 'quickActionWizard.dueDay' | t }}</span>
                <select
                  [ngModel]="paymentContract().abbuchungstag"
                  (ngModelChange)="updatePaymentContract('abbuchungstag', $event)"
                  name="contractDay"
                  [attr.aria-invalid]="hasFieldError('abbuchungstag')"
                  [class.quick-action-wizard__input--error]="hasFieldError('abbuchungstag')">
                  <option value="1">{{ 'modalCommon.firstOfMonth' | t }}</option>
                  <option value="15">{{ 'modalCommon.fifteenthOfMonth' | t }}</option>
                </select>
                @if (hasFieldError('abbuchungstag')) { <small>{{ validationMessage('abbuchungstag') }}</small> }
              </label>
              <div class="quick-action-wizard__actions">
                @if (canGoBack()) {
                  <button type="button" class="quick-action-wizard__secondary" data-track="wizard_back" (click)="goBack()">{{ 'quickActionWizard.back' | t }}</button>
                }
                <button type="submit" data-track="payment_submit" class="quick-action-wizard__primary">{{ 'quickActionWizard.confirmAgreement' | t }}</button>
              </div>
            </form>
            }

            @case ('installment_contract_review') {
              <section class="quick-action-wizard__review" aria-labelledby="quick-action-review-title">
                <header class="quick-action-wizard__review-status" role="status">
                  <strong id="quick-action-review-title">{{ 'quickActionWizard.reviewReadyTitle' | t }}</strong>
                  <span>{{ 'quickActionWizard.reviewInfo' | t }}</span>
                </header>

                @if (installmentContract(current); as contract) {
                  <dl class="quick-action-wizard__review-metrics" [attr.aria-label]="'quickActionWizard.installmentTermsAria' | t">
                    @if (installmentSummary(current); as summary) {
                      <div><dt>{{ 'quickActionWizard.regularInstallments' | t }}</dt><dd>{{ summary.regularCount }} x {{ summary.regularAmount }}</dd></div>
                      <div><dt>{{ 'quickActionWizard.finalInstallment' | t }}</dt><dd>1 x {{ summary.finalAmount }}</dd></div>
                      @if (summary.totalAmount) {
                        <div><dt>{{ 'quickActionWizard.totalAmount' | t }}</dt><dd>{{ summary.totalAmount }}</dd></div>
                      }
                    } @else {
                      <div><dt>{{ 'quickActionWizard.monthlyRate' | t }}</dt><dd>{{ contract['rate'] }}</dd></div>
                    }
                    <div>
                      <dt>{{ 'quickActionWizard.duration' | t }}</dt>
                      <dd>{{ contract['laufzeit'] }}</dd>
                    </div>
                    <div>
                      <dt>{{ 'quickActionWizard.firstDueDate' | t }}</dt>
                      <dd>{{ firstInstallmentDue(current) }}</dd>
                    </div>
                    <div>
                      <dt>{{ 'quickActionWizard.paymentMethod' | t }}</dt>
                      <dd>{{ installmentPaymentMethodLabel(current) }}</dd>
                    </div>
                    @if (current.form_schema?.conditions) {
                      <div>
                        <dt>{{ 'quickActionWizard.rzvFee' | t }}</dt>
                        <dd>{{ selectedInstallmentFeeTotal(current) }}</dd>
                      </div>
                      <div><dt>{{ 'quickActionWizard.rzvFeeHonorar' | t }}</dt><dd>{{ selectedInstallmentFeeHonorar(current) }}</dd></div>
                      <div><dt>{{ 'quickActionWizard.rzvFeeAuslagen' | t }}</dt><dd>{{ selectedInstallmentFeeAuslagen(current) }}</dd></div>
                    }
                  </dl>
                }

                @if (installmentSchedule(current).length > 0) {
                  <section class="quick-action-wizard__review-card">
                    <h3 class="quick-action-wizard__review-card-title">{{ 'quickActionWizard.installmentSchedule' | t }}</h3>
                    <table class="quick-action-wizard__schedule">
                      <thead>
                        <tr>
                          <th scope="col">{{ 'quickActionWizard.rate' | t }}</th>
                          <th scope="col">{{ 'quickActionWizard.dueDate' | t }}</th>
                          <th scope="col">{{ 'quickActionWizard.amount' | t }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (row of installmentSchedule(current); track row.index) {
                          <tr>
                            <td>{{ row.index }}</td>
                            <td>
                              {{ row.due_date }}
                              @if (row.has_deviating_final_installment_note === true) {
                                <span class="quick-action-wizard__installment-note">{{ 'p1.finalInstallmentNote' | t }}</span>
                              }
                            </td>
                            <td>{{ row.amount }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </section>
                }

                @if (sepaMandateData(current); as mandate) {
                  <section class="quick-action-wizard__review-card">
                    <h3 class="quick-action-wizard__review-card-title">{{ 'quickActionWizard.sepaData' | t }}</h3>
                    <dl class="quick-action-wizard__summary-list">
                      <div><dt>{{ 'caseView.detailLabels.bank_iban' | t }}</dt><dd class="quick-action-wizard__mono">{{ mandate['iban'] }}</dd></div>
                      <div><dt>{{ 'quickActionWizard.accountHolder' | t }}</dt><dd>{{ mandate['kontoinhaber'] }}</dd></div>
                      <div><dt>{{ 'modalCommon.debitDay' | t }}</dt><dd>{{ installmentDebitDayValue(current) }}</dd></div>
                    </dl>
                  </section>
                } @else if (transferDetails(current); as transfer) {
                  <section class="quick-action-wizard__review-card">
                    <h3 class="quick-action-wizard__review-card-title">{{ 'quickActionWizard.bankTransferData' | t }}</h3>
                    <dl class="quick-action-wizard__summary-list">
                      <div><dt>{{ 'quickActionWizard.recipient' | t }}</dt><dd>{{ transfer.recipient || ('quickActionWizard.unavailable' | t) }}</dd></div>
                      <div><dt>{{ 'caseView.detailLabels.bank_iban' | t }}</dt><dd class="quick-action-wizard__mono">{{ transfer.iban || ('quickActionWizard.unavailable' | t) }}</dd></div>
                      @if (transfer.bic) { <div><dt>{{ 'caseView.detailLabels.bank_bic' | t }}</dt><dd class="quick-action-wizard__mono">{{ transfer.bic }}</dd></div> }
                      @if (transfer.bank) { <div><dt>{{ 'caseView.detailLabels.bank_name' | t }}</dt><dd>{{ transfer.bank }}</dd></div> }
                      <div><dt>{{ 'quickActionWizard.referencePurpose' | t }}</dt><dd class="quick-action-wizard__mono">{{ transfer.reference || ('quickActionWizard.referenceFallback' | t) }}</dd></div>
                      <div><dt>{{ installmentDebitDayLabel(current) }}</dt><dd>{{ installmentDebitDayValue(current) }}</dd></div>
                    </dl>
                  </section>
                }

                @if (installmentContactData(current); as contactData) {
                  <section class="quick-action-wizard__review-card">
                    <h3 class="quick-action-wizard__review-card-title">{{ 'quickActionWizard.contactTitle' | t }}</h3>
                    <dl class="quick-action-wizard__summary-list">
                      @if (contactData['email']) { <div><dt>{{ 'widget.email' | t }}</dt><dd>{{ contactData['email'] }}</dd></div> }
                      @if (contactData['telefon']) { <div><dt>{{ 'quickActionWizard.phone' | t }}</dt><dd>{{ contactData['telefon'] }}</dd></div> }
                      @if (contactData['callback_time_slot']) { <div><dt>{{ 'quickActionWizard.callbackTime' | t }}</dt><dd>{{ contactData['callback_time_slot'] }}</dd></div> }
                    </dl>
                  </section>
                }


              </section>

              <button type="button" class="quick-action-wizard__secondary quick-action-wizard__contract-view" [class.quick-action-wizard__contract-view--done]="contractViewed()" data-testid="installment-contract-download" [disabled]="loading()" data-track="contract_download" (click)="downloadInstallmentContract($event)">
                @if (contractViewed()) { <span aria-hidden="true">✓</span> }
                {{ 'quickActionWizard.viewContract' | t }}
              </button>
              @if (contractViewRequired()) {
                <p id="installment-contract-view-error" class="quick-action-wizard__validation" role="alert">
                  <span aria-hidden="true">!</span>
                  {{ 'quickActionWizard.openContractFirst' | t }}
                </p>
              }
              <div class="quick-action-wizard__confirmation">
                <input
                  id="installmentContractAccepted"
                  type="checkbox"
                  [checked]="installmentContractAccepted() && contractViewed()"
                  (change)="confirmInstallmentContract($event)"
                  [attr.aria-describedby]="contractViewRequired() ? 'installment-contract-view-error' : null"
                  name="installmentContractAccepted"
                  required
                  aria-required="true">
                <label for="installmentContractAccepted">{{ 'quickActionWizard.confirmContract' | t }}</label>
              </div>

              <footer class="quick-action-wizard__footer">
                <button type="button" class="quick-action-wizard__secondary" data-track="wizard_back" (click)="goBack()">{{ 'quickActionWizard.back' | t }}</button>
                <button type="button" class="quick-action-wizard__primary" [disabled]="!contractViewed() || !installmentContractAccepted() || loading()" data-track="payment_submit" (click)="submitInstallmentReview()">{{ 'quickActionWizard.submitContract' | t }}</button>
              </footer>
            }

            @case ('document_upload') {
            <div class="quick-action-wizard__section-head">
              <strong>{{ 'documentUploadModal.title' | t }}</strong>
              <span>{{ 'quickActionWizard.uploadInfo' | t }}</span>
              <ul class="cr-check-list quick-action-wizard__check-list">
                <li>{{ 'documentUploadModal.secure' | t }}</li>
                <li>{{ 'quickActionWizard.formatsShort' | t }}</li>
                <li>{{ 'documentUploadModal.assigned' | t }}</li>
              </ul>
            </div>
            @if (showDevHelper) {
              <div class="quick-action-wizard__dev-helper" role="note">
                <div>
                  <strong>{{ 'modalCommon.devDataTitle' | t }}</strong>
                  <span>{{ 'documentUploadModal.devBody' | t }}</span>
                </div>
                <button type="button" class="quick-action-wizard__secondary" (click)="insertDocumentUploadTestData()">{{ 'modalCommon.insertTestData' | t }}</button>
              </div>
            }
            <form class="quick-action-wizard__form" (ngSubmit)="submitDocumentUpload()">
              <div class="quick-action-wizard__field">
                <span>{{ 'quickActionWizard.files' | t }}</span>
                <input
                  id="quick-action-document-file"
                  type="file"
                  name="documentFile"
                  [accept]="documentUploadAccept"
                  multiple
                  class="quick-action-wizard__file-input"
                  (change)="onDocumentFileSelect($event)"
                  [attr.aria-invalid]="hasFieldError('filename')">
                <label
                  class="quick-action-wizard__file-button"
                  [class.quick-action-wizard__file-button--error]="hasFieldError('filename')"
                  for="quick-action-document-file">
                  {{ 'documentUploadModal.chooseFiles' | t }}
                </label>
                <small class="quick-action-wizard__file-name" aria-live="polite">
                  {{ documentUpload().filename || documentFilesStatus() }}
                </small>
                @if (hasFieldError('filename')) { <small>{{ validationMessage('filename') }}</small> }
              </div>
              @if (documentUploadProgress() > 0 && documentUploadProgress() < 100) {
                <div class="quick-action-wizard__upload-progress" role="progressbar" [attr.aria-valuenow]="documentUploadProgress()" aria-valuemin="0" aria-valuemax="100">
                  <span [style.width.%]="documentUploadProgress()"></span>
                </div>
              }
              <label>
                <span>{{ 'documentUploadModal.category' | t }}</span>
                <select
                  [ngModel]="documentUpload().category"
                  (ngModelChange)="updateDocumentUpload('category', $event)"
                  name="documentCategory"
                  [attr.aria-invalid]="hasFieldError('category')"
                  [class.quick-action-wizard__input--error]="hasFieldError('category')">
                  <option value="proof">{{ 'documentUploadModal.categoryProof' | t }}</option>
                  <option value="invoice">{{ 'quickActionWizard.invoice' | t }}</option>
                  <option value="correspondence">{{ 'documentUploadModal.categoryCorrespondence' | t }}</option>
                  <option value="other">{{ 'documentUploadModal.categoryOther' | t }}</option>
                </select>
                @if (hasFieldError('category')) { <small>{{ validationMessage('category') }}</small> }
              </label>
              <label>
                <span>{{ 'documentUploadModal.reason' | t }} *</span>
                <input
                  type="text"
                  [ngModel]="documentUpload().reason"
                  (ngModelChange)="updateDocumentUpload('reason', $event)"
                  name="documentReason"
                  aria-required="true"
                  [attr.aria-invalid]="hasFieldError('reason')"
                  [class.quick-action-wizard__input--error]="hasFieldError('reason')">
                @if (hasFieldError('reason')) { <small>{{ validationMessage('reason') }}</small> }
              </label>
              <label>
                <span>{{ 'documentUploadModal.comment' | t }}</span>
                <textarea
                  id="quick-action-document-comment"
                  rows="3"
                  [ngModel]="documentUpload().comment"
                  (ngModelChange)="updateDocumentUpload('comment', $event)"
                  name="documentComment"
                  [attr.aria-invalid]="hasFieldError('comment') || !hasValidDocumentUploadComment()"
                  [attr.aria-describedby]="hasValidDocumentUploadComment() ? 'quick-action-document-comment-counter' : 'quick-action-document-comment-counter quick-action-document-comment-error'"
                  [class.quick-action-wizard__input--error]="hasFieldError('comment') || !hasValidDocumentUploadComment()">
                </textarea>
                <small id="quick-action-document-comment-counter">
                  {{ documentUploadCommentLength() }} / {{ documentUploadCommentMaxLength }}
                </small>
                @if (!hasValidDocumentUploadComment()) {
                  <small id="quick-action-document-comment-error" role="alert">
                    {{ (isDocumentUploadCommentTooLong() ? 'documentUploadModal.commentTooLong' : 'documentUploadModal.commentInvalid') | t }}
                  </small>
                }
                @if (hasFieldError('comment')) { <small>{{ validationMessage('comment') }}</small> }
              </label>
              <div class="quick-action-wizard__actions">
                <button type="submit" class="quick-action-wizard__primary" [disabled]="!hasValidDocumentUploadComment() || loading()">{{ 'quickActionWizard.sendDocument' | t }}</button>
              </div>
            </form>
          }

          @case ('contact_form') {
            <div class="quick-action-wizard__section-head">
              @if (isInstallmentContactContext(current)) {
                <strong>{{ 'quickActionWizard.installmentContactTitle' | t }}</strong>
                <span>{{ 'quickActionWizard.installmentContactInfo' | t }}</span>
              } @else {
                <strong>{{ 'quickActionWizard.contactTitle' | t }}</strong>
                <span>{{ 'quickActionWizard.contactInfo' | t }}</span>
                <ul class="cr-check-list quick-action-wizard__check-list">
                  <li>{{ 'quickActionWizard.contactQuick' | t }}</li>
                  <li>{{ 'quickActionWizard.contactCallback' | t }}</li>
                  <li>{{ 'quickActionWizard.contactConfidential' | t }}</li>
                </ul>
              }
            </div>
            @if (showDevHelper) {
              <div class="quick-action-wizard__dev-helper" role="note">
                <div>
                  <strong>{{ 'modalCommon.devDataTitle' | t }}</strong>
                  <span>{{ isInstallmentContactContext(current) ? ('quickActionWizard.devInstallmentContact' | t) : ('quickActionWizard.devContact' | t) }}</span>
                </div>
                <button type="button" class="quick-action-wizard__secondary" (click)="insertContactTestData()">{{ 'modalCommon.insertTestData' | t }}</button>
              </div>
            }
            <form class="quick-action-wizard__form" (ngSubmit)="submitContact()">
              <label>
                <span>{{ 'widget.email' | t }}</span>
                <input
                  type="email"
                  [ngModel]="contact().email"
                  (ngModelChange)="updateContact('email', $event)"
                  name="contactEmail"
                  autocomplete="email"
                  [required]="isInstallmentContactContext(current)"
                  [attr.aria-invalid]="hasFieldError('email')"
                  [class.quick-action-wizard__input--error]="hasFieldError('email')">
                @if (hasFieldError('email')) { <small>{{ validationMessage('email') }}</small> }
              </label>
              <label>
                <span>{{ 'quickActionWizard.phone' | t }}</span>
                <input
                  type="tel"
                  [ngModel]="contact().telefon"
                  (ngModelChange)="updateContact('telefon', $event)"
                  name="contactPhone"
                  autocomplete="tel"
                  [attr.aria-invalid]="hasFieldError('telefon') || hasFieldError('contact')"
                  [class.quick-action-wizard__input--error]="hasFieldError('telefon') || hasFieldError('contact')">
                @if (hasFieldError('telefon')) { <small>{{ validationMessage('telefon') }}</small> }
                @if (hasFieldError('contact')) { <small>{{ validationMessage('contact') }}</small> }
              </label>
              @if (!isInstallmentContactContext(current)) {
                <label>
                  <span>{{ 'quickActionWizard.message' | t }}</span>
                  <textarea
                    rows="4"
                    [ngModel]="contact().message"
                    (ngModelChange)="updateContact('message', $event)"
                    name="contactMessage"
                    [attr.aria-invalid]="hasFieldError('message')"
                    [class.quick-action-wizard__input--error]="hasFieldError('message')">
                  </textarea>
                  @if (hasFieldError('message')) { <small>{{ validationMessage('message') }}</small> }
                </label>
                <div class="quick-action-wizard__field">
                  <span>{{ 'quickActionWizard.callbackTime' | t }}</span>
                  <button
                    #callbackTrigger
                    type="button"
                    class="quick-action-wizard__callback-trigger"
                    aria-controls="quick-action-contact-callback-options"
                    [attr.aria-expanded]="contactCallbackExpanded()"
                    [attr.aria-invalid]="hasFieldError('callback_time_slot')"
                    [class.quick-action-wizard__input--error]="hasFieldError('callback_time_slot')"
                    (click)="toggleContactCallbackExpanded(callbackTrigger)">
                    <span class="quick-action-wizard__callback-summary">
                      @if (contact().callback_time_slot) {
                        {{ contactCallbackTimeSlotLabel() }}
                      } @else {
                        {{ 'contactModal.noSelection' | t }}
                      }
                    </span>
                    <span class="quick-action-wizard__callback-chevron" aria-hidden="true">v</span>
                  </button>

                  @if (contactCallbackExpanded()) {
                    <div
                      id="quick-action-contact-callback-options"
                      class="quick-action-wizard__callback-panel"
                      role="group"
                      [attr.aria-label]="'quickActionWizard.callbackTime' | t">
                      <div class="quick-action-wizard__callback-head" aria-hidden="true">
                        <span></span>
                        @for (period of callbackPeriods; track period) {
                          <span>{{ callbackPeriodLabel(period) }}</span>
                        }
                      </div>

                      @for (day of callbackWeekdays; track day.key) {
                        <div class="quick-action-wizard__callback-row">
                          <span class="quick-action-wizard__callback-day">{{ callbackDayLabel(day.key) }}</span>
                          @for (period of callbackPeriods; track period) {
                            <label class="quick-action-wizard__callback-slot">
                              <input
                                type="checkbox"
                                [name]="'contactCallbackTimeSlot_' + day.key + '_' + period"
                                [checked]="isContactCallbackSlotSelected(day.key, period)"
                                (change)="onContactCallbackSlotChange(day.key, period, $event)" />
                              <span>{{ callbackPeriodLabel(period) }}</span>
                            </label>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (hasFieldError('callback_time_slot')) { <small>{{ validationMessage('callback_time_slot') }}</small> }
                </div>
              }
                <div class="quick-action-wizard__actions">
                  @if (current.action_type === 'payment' && canGoBack()) {
                    <button type="button" class="quick-action-wizard__secondary" data-track="wizard_back" (click)="goBack()">{{ 'quickActionWizard.back' | t }}</button>
                  }
                  <button type="submit" class="quick-action-wizard__primary">{{ current.action_type === 'payment' ? ('quickActionWizard.next' | t) : ('quickActionWizard.sendContact' | t) }}</button>
                </div>
            </form>
          }
          }
        }
      }
    </div>

    @if (confirmCloseVisible()) {
      <div class="quick-action-wizard__confirm" role="alertdialog" aria-modal="true" aria-labelledby="quick-action-wizard-confirm-title">
        <div class="quick-action-wizard__confirm-dialog">
          <h3 id="quick-action-wizard-confirm-title" class="quick-action-wizard__confirm-title">{{ 'quickActionWizard.confirmCloseTitle' | t }}</h3>
          <p class="quick-action-wizard__confirm-text">{{ closeConfirmText() }}</p>
          <div class="quick-action-wizard__confirm-actions">
            <button type="button" class="quick-action-wizard__secondary" (click)="cancelCloseRequest()">{{ 'common.cancel' | t }}</button>
            <button type="button" class="quick-action-wizard__danger" data-track="wizard_confirm_close" (click)="confirmClose()">{{ 'common.close' | t }}</button>
          </div>
        </div>
      </div>
    }
  </section>
</div>
